import {specialOffersActionTypes, staticPagesActionTypes} from "../constants/ActionTypes";

const initialState = {
  specialOffers: [],
  specialOffer: null,
  pagination: {
    currentPage: 1,
    pagesCount: 0,
    recordsCount: 0
  },
};

const specialOffers = (state = initialState, action) => {
  switch (action.type) {
    case specialOffersActionTypes.SET_SPECIAL_OFFERS_LIST:
      return Object.assign({}, state, {
        specialOffers: action.specialOffers,
        pagination: action.pagination
      });
    case specialOffersActionTypes.GET_SPECIAL_OFFER:
      return {
        ...state,
        specialOffer: action.specialOffer
      };
  }
  return state;
};

export default specialOffers;



// WEBPACK FOOTER //
// ./reducers/specialOffers.reducers.js